import PowersportsAsset from '../asset/powersports-asset';
import configuration from '../configuration';
import GenericCta from './generic-cta';
import { infoButtonComponent } from '../util/svg-component';

export default class PowersportsCta extends GenericCta<PowersportsAsset> {
  buildCtaElement(asset: PowersportsAsset, rate: number): HTMLElement {
    if (this.style === 'cfmoto-summary') {
      return this.buildCFMotoSummaryCtaElement();
    } else if (this.style === 'oval') {
      return this.buildOvalCtaElement(asset, rate);
    } else {
      return super.buildCtaElement(asset, rate);
    }
  }

  buildCFMotoSummaryCtaElement(): HTMLElement {
    // CTA Container
    const cta = document.createElement('button');
    cta.type = 'button';
    cta.classList.add('ol-cta', 'ol-cta-summary');
    cta.addEventListener('click', this.handleOnClick.bind(this));
    const buttonText = this.createElement('span', ['ol-button-text-summary']);
    buttonText.dataset.linksInitialized = 'false';
    buttonText.appendChild(this.createElement('span', [], configuration.cta_text));
    cta.appendChild(buttonText);

    return cta;
  }

  buildOvalCtaElement(asset: PowersportsAsset, rate: number): HTMLElement {
    // CTA Container
    const cta = document.createElement('div');
    // Add generic CTA classes
    cta.classList.add('ol-cta-oval');

    // Prepare buttonContainer
    const buttonContainer = document.createElement('div');
    buttonContainer.classList.add('ol-button-container-oval', 'ol-button-container-search');
    const button = this.createElement('button', ['oval-button', 'ol-button-oval']);
    button.type = 'button';
    button.dataset.linksInitialized = 'false';
    button.appendChild(this.createElement('span', ['ol-button-text-oval'], configuration.cta_text));
    button.addEventListener('click', this.handleOnClick.bind(this));
    buttonContainer.appendChild(button);

    const msrpContainer = this.createElement('div', ['ol-msrp-container', 'ol-msrp-container-search']);
    const rateContainer = this.createElement('div', ['ol-rate-container-search']);
    const tooltipLink = this.createElement('div', ['ol-tooltip-link-oval']);
    tooltipLink.appendChild(this.createElement('p', ['ol-msrp-oval'], 'from'));
    tooltipLink.appendChild(this.createElement('p', ['ol-title-oval', 'ol-msrp-oval'], `$${rate}/mo`));
    tooltipLink.appendChild(infoButtonComponent());
    rateContainer.appendChild(tooltipLink);
    msrpContainer.appendChild(rateContainer);
    msrpContainer.appendChild(this.createElement('p', ['ol-msrp-subtitle-oval'], 'Instant | No credit impact'));
    cta.appendChild(msrpContainer);

    cta.append(buttonContainer);

    return cta;
  }
}
